import { h, T } from '@jsx6/jsx6'
/**
 * 
 * @param {Element} logo 
 * @param {ChatBox} chat 
 * @returns Element
 */
export const areaSettings = (chat) => {
  return (
    <div p="area.settings" class="chatForm" hidden>
      {chat.logo}
      <div class="chatHeading">
        <div class="heading-content">{T`device_settings`}</div>
        <div class="chatTopbar">
          <span p="bt.minimize" onclick={e => chat.minimize()} icon="x-mark" />
        </div>
      </div>
      <div p="deviceSelectionWrapper">
        <div p="setting.deviceSelection">
          <div p="area2.settingsVideo"></div>

          <div class="form-line" p="area2.audioIn">
            <label>{T`audio_input`}</label>
            <select p="settings.audioIn" />
          </div>

          <div class="form-line" p="area2.audioOut">
            <label>{T`audio_output`}</label>
            <select p="settings.audioOut" />
            <div p="setSinkIdInstructions" hidden><a href="https://github.com/jitsi/jitsi-meet/issues/7669#issuecomment-715989147" target="_blank">{T`instructions_enable_media_setsinkid`}</a></div>
          </div>

          <div class="form-line" p="area2.videoIn">
            <label>{T`video_input`}</label>
            <select p="settings.videoIn" />
          </div>

          <div p="inviteText" class="invite-info">{T`invite_text`}</div>
        </div>
      </div>

      <div class="form-line buttons-line">
        <button p="bt.start" class="btn btn-primary" onclick={e => chat.startInvite(true)}>
          {T`start_chat`}
        </button>
      </div>
    </div>
  )
}
